import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';
import MembershipTicketSkeleton from 'components/skeleton/MembershipTicketSkeleton';
import companyInforAtom from 'atom/companyInfoAtom';
import { useAtomValue } from 'jotai';
import SubscribeCardLayout from 'layout/SubscribeCardLayout';
import SubscribeHistoryLayout from 'layout/SubscribeHistoryLayout';
import { QueryKeys, restfetcher } from 'queryClient';
import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import styled from 'styled-components';
import uuid from 'react-uuid';

const MemberShip = () => {
  const companyInfor = useAtomValue(companyInforAtom);

  const membershipDataApi = useQuery({
    queryKey: [QueryKeys.MEMBERSHIP, companyInfor.companyidx],
    queryFn: () =>
      restfetcher({
        method: 'POST',
        path: 'biz/membership/find',
        params: {
          companyidx: companyInfor?.companyidx
        }
      }),
    enabled: companyInfor.companyidx !== 0
  });

  const { data: membershipData } = membershipDataApi;

  const membershipTicketList = membershipData?.membership;

  useEffect(() => {
    if (membershipTicketList) {
      const initialCartData = membershipTicketList.map((ticket: MemberShipDataTypes) => ({
        ...ticket,
        cart: false,
        count: 0,
        uuid: uuid(),
        divisiondata: ticket.divisiondata.map((division) => ({
          ...division,
          originalRecommendyn: division.recommendyn
        }))
      }));
      setMembership(initialCartData);
    }
  }, [membershipTicketList]);

  const memberShipData: MemberShipDataTypes[] | undefined =
    membershipDataApi.status === 'success' ? membershipDataApi.data?.membership : undefined;

  const [memberShip, setMembership] = useState<MemberShipDataTypes[] | undefined>(memberShipData);
  const [cartData, setCartData] = useState<MemberShipDataTypes[]>([]);

  return (
    <Wrapper>
      <ImageWrapper>
        <Image src="/images/membership_bg.png" alt="membership_bg" />
        <h2>Biz Membership</h2>
      </ImageWrapper>
      <CardLayoutWrapper>
        <div>
          <h2>비즈멤버십 구독하기</h2>
          <CountWrapper>
            <TextWrapper>
              <p>
                구매하실 멤버십을 선택 후 장바구니에 담아주세요. <br />
                멤버십 구매 수량은 장바구니 내에서 수정할 수 있습니다.
              </p>
            </TextWrapper>
          </CountWrapper>
          {memberShip ? (
            <SubscribeCardLayout
              membershipData={memberShip}
              setMembershipData={setMembership}
              cartData={cartData}
              setCartData={setCartData}
            />
          ) : (
            <MembershipTicketSkeleton />
          )}
        </div>
        <SubscribeHistoryLayout cartData={cartData} setCartData={setCartData} />
      </CardLayoutWrapper>
    </Wrapper>
  );
};

export default MemberShip;

const Wrapper = styled.div`
  max-width: 1440px;
  padding: 0 48px;
  margin: 0 auto;
`;

const CountWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 32px 0;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  p {
    line-height: 20px;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  height: 320px;

  h2 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    ${font.d1_bold};
    color: ${color.white};
    text-align: center;
    text-shadow: 0px 0px 16px ${color.opacityBlack02};
  }

  img {
    width: 100%;
  }
`;

const Image = styled.img`
  border-radius: 24px;
`;

const CardLayoutWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  gap: 64px;
  padding-top: 69px;

  & h2 {
    color: ${color.black2};
    ${font.h1_bold};
  }

  & > div {
    display: flex;
    flex-direction: column;
  }
`;
